import { useState } from "react"
import { DateTime } from "luxon"
import { Tooltip, TooltipContent, TooltipTrigger } from "@components/ui/tooltip"
import type { IConversation } from "@apis/conversations/types"

type TAccountEventItemProps = {
  conversation: IConversation
}

const MAX_CHARS = 1000

export const ConversationItem = ({ conversation }: TAccountEventItemProps) => {
  const [expanded, setExpanded] = useState(false)

  const timeAgo =
    DateTime.fromISO(conversation.created_at).toRelative({ locale: "en" }) || ""
  const formattedDate = DateTime.fromISO(
    conversation.created_at,
  ).toLocaleString(DateTime.DATETIME_SHORT)

  const rawHtml = (conversation.message_content as string) || ""
  const isLongContent = rawHtml.length > MAX_CHARS
  const htmlToRender =
    expanded || !isLongContent ? rawHtml : rawHtml.slice(0, MAX_CHARS)

  return (
    <div className="tw:flex tw:gap-2 tw:border-b tw:border-gray-200 tw:py-4">
      <div className="tw:w-2/12 tw:text-center tw:text-[#777]">
        <p className="tw:text-[10.5px] tw:font-normal">{`${conversation.type} from:`}</p>
        <p className="tw:text-[13.5px] tw:font-bold">
          {conversation.initiator}
        </p>
        <p className="tw:text-[10.5px] tw:font-normal">
          <span className="tw:font-bold">Conversation Item Id:</span>{" "}
          {conversation.conversation_item_id}
        </p>
        <Tooltip key={conversation.created_at}>
          <TooltipTrigger>
            <div className="tw:mt-1 tw:text-xs tw:text-muted-foreground">
              {timeAgo}
            </div>
          </TooltipTrigger>
          <TooltipContent side="bottom">
            <span>{formattedDate}</span>
          </TooltipContent>
        </Tooltip>
      </div>

      <div className="tw:w-10/12">
        {conversation.content.type === "EMAIL" && (
          <p className="tw:font-bold">{conversation.content.subject}</p>
        )}
        <div
          className="tw:mt-1 tw:text-xs tw:whitespace-pre-wrap tw:text-gray-600"
          dangerouslySetInnerHTML={{
            __html: htmlToRender,
          }}
        />
        {isLongContent && (
          <button
            type="button"
            className="hover:tw:underline tw:mt-1 tw:text-xs tw:font-medium tw:text-sky-700"
            onClick={() => setExpanded((expand) => !expand)}
          >
            {expanded ? "view less" : "view more"}
          </button>
        )}
      </div>
    </div>
  )
}
